/**
 * @module planejamento/planejamento
 */

import { Plugin } from 'ckeditor5/src/core';
import PlanejamentoEditing from './planejamentoediting';
import PlanejamentoLabelEditing from './label/planejamentolabelediting';
import '../theme/planejamento.pcss';

/**
 * The planejamento plugin.
 *
 * It loads the {@link module:planejamento/planejamentoediting~PlanejamentoEditing PlanejamentoEditing feature}
 * and {@link module:planejamento/ui/planejamentoui~PlanejamentoUI PlanejamentoUI feature}
 * and {@link module:planejamento/label/planejamentolabelediting~PlanejamentoLabelEditing PlanejamentoLabelEditing feature}
 * and {@link module:planejamento/ui/planejamentolabelui~PlanejamentoLabelUI PlanejamentoLabelUI feature}.
 *
 * @extends {Plugin}
 */
export default class Planejamento extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'Planejamento';
	}

	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ PlanejamentoEditing, PlanejamentoLabelEditing ];
	}
}
